var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeSwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "14px",
    viewBox: "0 0 21 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5D25AAD3-C754-41EE-9267-101C2F07452B") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Operator",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Login-Page---Error",
    transform: "translate(-845.000000, -474.000000)",
    fill: "#304258",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "view-icon",
    transform: "translate(845.503080, 474.564916)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 9.97801141,
    cy: 6.451735,
    r: 3.07225476
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6498534,5.60072043 C17.288288,2.74697979 13.7135276,0 9.97801141,0 C6.24176559,0 2.66616029,2.74889995 0.306169388,5.60072043 C-0.102056463,6.09381732 -0.102056463,6.80965268 0.306169388,7.30274957 C0.899498589,8.01973702 2.14337774,9.40378779 3.8046995,10.6131041 C7.98868805,13.6589374 11.958118,13.665658 16.1513233,10.6131041 C17.8126451,9.40378779 19.0565242,8.01973702 19.6498534,7.30274957 C20.0568888,6.81061276 20.059001,6.09543025 19.6498534,5.60072043 Z M9.97801141,2.15057833 C12.3497921,2.15057833 14.2791681,4.07995432 14.2791681,6.451735 C14.2791681,8.82351567 12.3497921,10.7528917 9.97801141,10.7528917 C7.60623073,10.7528917 5.67685474,8.82351567 5.67685474,6.451735 C5.67685474,4.07995432 7.60623073,2.15057833 9.97801141,2.15057833 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeSwitch);
export default __webpack_public_path__ + "static/media/eye-switch.cc3ae7690278f19264d97707fe69c9aa.svg";
export { ForwardRef as ReactComponent };